import * as React from 'react';
import { useAuth0 } from "@auth0/auth0-react";
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import { LoginButton } from '../buttons/login-button';
import { ProfileButton } from '../buttons/profile-button';
import Drawer from '@mui/material/Drawer';
import { Divider, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import GavelIcon from '@mui/icons-material/Gavel';
import CheckListIcon from '@mui/icons-material/Checklist';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';
import TeamAdminIcon from '@mui/icons-material/SupervisorAccount';
import MoveUpIcon from '@mui/icons-material/MoveUp';
import TuneIcon from '@mui/icons-material/Tune';
import BackupIcon from '@mui/icons-material/Backup';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import BarChartIcon from '@mui/icons-material/BarChart';
import { useNavigate } from "react-router-dom";
import { useSiteVarsFunctions } from "../../hooks/use-site-vars-functions";

export const TopNavBar = () => {
  const { isAuthenticated } = useAuth0();
  const { user } = useAuth0();
  const { getTransfersOpen } = useSiteVarsFunctions();
  const [drawerState, setDrawerState] = React.useState(false);
  const navigate = useNavigate(); 

  const toggleDrawer = (open) => (event) => {
    setDrawerState(open);
  };

  const isContentAdmin = () => {
    //Dan - 11
    //Phil - 1
    //Nick - 10
    //Stu - 5
    return [11, 1, 10, 5].indexOf(user['https://tlog-online.co.uk/club_id']) > -1;
  }

  return (
    <Box sx={{ flexGrow: 1, boxShadow:0.5, marginBottom:1 }}>
      <AppBar position="static" sx={{ backgroundColor: 'white' }}>
        <Toolbar>
          <IconButton
            size="large"
            edge="start"
            color="0073e6"
            aria-label="menu"
            sx={{ mr: 2, paddingRight:'2px' }}
            onClick={toggleDrawer(true)}
          >
            <MenuIcon />
          </IconButton>
          <Drawer
            anchor="left"
            open={drawerState}
            onClose={toggleDrawer(false)}
          >
            <Box
              sx={{ width: 250 }}
              role="presentation"
              onClick={toggleDrawer(false)}
              onKeyDown={toggleDrawer(false)}
            >
              <List>
                <ListItem disablePadding>
                  <ListItemButton onClick={() => navigate("/")}>
                    <ListItemIcon>
                      <HomeIcon />
                    </ListItemIcon>
                    <ListItemText primary="Home" />
                  </ListItemButton>
                </ListItem>
                <ListItem disablePadding>
                  <ListItemButton onClick={() => navigate("/auction-list")}>
                    <ListItemIcon>
                      <CheckListIcon />
                    </ListItemIcon>
                    <ListItemText primary="Auction List" />
                  </ListItemButton>
                </ListItem>
                <ListItem disablePadding>
                  <ListItemButton onClick={() => navigate("/auction-results")}>
                    <ListItemIcon>
                      <GavelIcon />
                    </ListItemIcon>
                    <ListItemText primary="Auction Results" />
                  </ListItemButton>
                </ListItem>
                <ListItem disablePadding>
                  <ListItemButton onClick={() => navigate("/rules")}>
                    <ListItemIcon>
                      <MenuBookIcon />
                    </ListItemIcon>
                    <ListItemText primary="Rules" />
                  </ListItemButton>
                </ListItem>
                <ListItem disablePadding>
                  <ListItemButton onClick={() => navigate("/statistics")}>
                    <ListItemIcon>
                      <BarChartIcon />
                    </ListItemIcon>
                    <ListItemText primary="Statistics" />
                  </ListItemButton>
                </ListItem>
                <ListItem disablePadding>
                  <ListItemButton onClick={() => navigate("/score-breakdown")}>
                    <ListItemIcon>
                      <PlaylistAddCheckIcon />
                    </ListItemIcon>
                    <ListItemText primary="Score Breakdown" />
                  </ListItemButton>
                </ListItem>
              </List>
              <Divider />
              {isAuthenticated && (
              <div>
                <List>
                  {(getTransfersOpen()) && (
                    <ListItem disablePadding>
                      <ListItemButton onClick={() => navigate("/transfers")}>
                        <ListItemIcon>
                          <CheckListIcon />
                        </ListItemIcon>
                        <ListItemText primary="Transfers" />
                      </ListItemButton>
                    </ListItem>
                  )}
                  <ListItem disablePadding>
                    <ListItemButton onClick={() => navigate("/loans")}>
                      <ListItemIcon>
                        <MoveUpIcon />
                      </ListItemIcon>
                      <ListItemText primary="Loans" />
                    </ListItemButton>
                  </ListItem>
                  {(isContentAdmin()) && (
                  <ListItem disablePadding>
                    <ListItemButton onClick={() => navigate("/admin/scraper")}>
                      <ListItemIcon>
                          <BackupIcon />
                      </ListItemIcon>
                      <ListItemText primary="Scraper" />
                    </ListItemButton>
                  </ListItem>
                  )}
                </List>
                <Divider />
              </div>
              )}
              {(isAuthenticated && user['https://tlog-online.co.uk/club_id'] === 11) && (
              <div>
                <List>
                  <ListItem disablePadding>
                    <ListItemButton onClick={() => navigate("/admin/site-vars")}>
                      <ListItemIcon>
                          <TuneIcon />
                      </ListItemIcon>
                      <ListItemText primary="Site Vars" />
                    </ListItemButton>
                  </ListItem>
                  <ListItem disablePadding>
                    <ListItemButton onClick={() => navigate("/admin/update-week")}>
                      <ListItemIcon>
                          <TuneIcon />
                      </ListItemIcon>
                      <ListItemText primary="Update Week" />
                    </ListItemButton>
                  </ListItem>
                  <ListItem disablePadding>
                    <ListItemButton onClick={() => navigate("/admin/team-admin")}>
                      <ListItemIcon>
                          <TeamAdminIcon />
                      </ListItemIcon>
                      <ListItemText primary="Team Admin" />
                    </ListItemButton>
                  </ListItem>
                  <ListItem disablePadding>
                    <ListItemButton onClick={() => navigate("/admin/manage-transfers")}>
                      <ListItemIcon>
                          <AccountBalanceWalletIcon />
                      </ListItemIcon>
                      <ListItemText primary="Manage Transfers" />
                    </ListItemButton>
                  </ListItem>
                  <ListItem disablePadding>
                    <ListItemButton onClick={() => navigate("/admin/confirmed-teams")}>
                      <ListItemIcon>
                          <AccountBalanceWalletIcon />
                      </ListItemIcon>
                      <ListItemText primary="Confirmed Teams" />
                    </ListItemButton>
                  </ListItem>
                </List>
                <Divider />
              </div>
              )}
            </Box>
          </Drawer>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1, color:'#0073e6' }}>
            TLOG
          </Typography>
          {!isAuthenticated && (
            <>
              <LoginButton />
            </>
          )}
          {isAuthenticated && (
            <>
              <ProfileButton />
            </>
          )}
        </Toolbar>
      </AppBar>
    </Box>
  );
}
